module.exports = __webpack_public_path__ + "img/github.e4615ead.svg";